import { CURRENCIES, type CurrencyCode, type CurrencyMetadata } from './currency-codes.generated.ts'

export {
  CurrencyCode,
  CURRENCIES,
  type CurrencyMetadata,
  type SymbolPosition,
} from './currency-codes.generated.ts'

export function isCurrencyCode(value: string): value is CurrencyCode {
  return Object.hasOwn(CURRENCIES, value)
}

export function requireCurrencyCode(value: string): CurrencyCode {
  if (!isCurrencyCode(value)) throw new UnknownCurrencyError(value)
  return value
}

export function currencyMetadata(currency: CurrencyCode): CurrencyMetadata {
  return CURRENCIES[currency]
}

export class UnknownCurrencyError extends Error {
  readonly code = 'domain.unknown_currency'
  readonly value: string
  constructor(value: string) {
    super(`Unknown currency code: ${value}`)
    this.name = 'UnknownCurrencyError'
    this.value = value
  }
}

/** The most fraction digits a currency's amounts are ever shown with (0 for HUF). Wire scale is always 4. */
export function displayDigitsFor(currency: CurrencyCode): number {
  return CURRENCIES[currency].displayFractionDigits
}
